import React from 'react';
import { Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarDays,
  faClock,
  faPenToSquare,
  faTrash,
  faCircleInfo,
} from '@fortawesome/free-solid-svg-icons';
import type { ScheduleListProps } from './types';
import type { Schedule } from '../../redux/schedulesSlice';
import {
  ContentCard,
  StyledCollapse,
  ScheduleTimeRow,
  MetaText,
  ActionBar,
  EditButton,
  DeleteButton,
  TitleIcon,
  TooltipIconWrap,
  EmptyState,
} from './styles';

const formatDateTime = (dateStr: string): string =>
  new Date(dateStr).toLocaleString();

const ScheduleList: React.FC<ScheduleListProps> = ({ schedules, onEdit, onDelete }) => {
  const renderPanelHeader = (schedule: Schedule) => (
    <span>
      <TitleIcon>
        <FontAwesomeIcon icon={faCalendarDays} />
      </TitleIcon>
      {schedule.day_names.length > 0 ? (
        schedule.day_names.join(', ')
      ) : (
        <Tooltip title="No specific days, applies to all days">
          <span>
            All Days
            <TooltipIconWrap>
              <FontAwesomeIcon icon={faCircleInfo} />
            </TooltipIconWrap>
          </span>
        </Tooltip>
      )}
    </span>
  );

  const items = schedules.map((schedule) => ({
    key: schedule.id,
    label: renderPanelHeader(schedule),
    children: (
      <>
        <ScheduleTimeRow>
          <FontAwesomeIcon icon={faClock} />
          {schedule.start_time} – {schedule.end_time}
        </ScheduleTimeRow>
        <MetaText>Created at: {formatDateTime(schedule.created_at)}</MetaText>
        <MetaText>Updated at: {formatDateTime(schedule.updated_at)}</MetaText>
        <ActionBar>
          <EditButton
            type="default"
            icon={<FontAwesomeIcon icon={faPenToSquare} />}
            onClick={() => onEdit(schedule)}
          >
            Edit Schedule
          </EditButton>
          <DeleteButton
            type="primary"
            danger
            icon={<FontAwesomeIcon icon={faTrash} />}
            onClick={() => onDelete(schedule.id)}
          >
            Delete
          </DeleteButton>
        </ActionBar>
      </>
    ),
  }));

  if (schedules.length === 0) {
    return (
      <ContentCard>
        <EmptyState>All the available schedu   les. See details, create, delete or update existing schedules.</EmptyState>
      </ContentCard>
    );
  }

  return (
    <ContentCard>
      <StyledCollapse items={items} accordion={false} defaultActiveKey={[]} expandIconPosition="end" />
    </ContentCard>
  );
};

export default React.memo(ScheduleList);
